import _ from 'lodash';
import Emittery from 'emittery';

export class Plugin extends Emittery {

  constructor( opts = {} ) {
    super();
    _.assign( this, opts );
  }

  get name() {
    return this.constructor.name.replace( /Plugin$/u, '' ).toLowerCase();
  }

  /**
   * Connect the plugin instance to the application instance, and
   * perform any initialization.
   *
   * @param {object} app - The application instance.
   */
  onInit( app ) { }

}
